export const toggleLanguageValue = (language) => (language === 'ar' ? 'en' : 'ar');

export const updateSettingsField = (settings, field, value) => ({
  ...(settings || {}),
  [field]: value
});

export const applyDensityToDocument = ({ documentRef, density }) => {
  const root = documentRef?.documentElement;
  if (!root) return;

  root.classList.remove('density-comfortable', 'density-compact');
  root.classList.add(`density-${density || 'comfortable'}`);
};

export const applyThemeToDocument = ({ documentRef, theme, matchMediaRef }) => {
  const root = documentRef?.documentElement;
  if (!root) return;

  root.classList.remove('light', 'dark');

  if (theme === 'system') {
    const systemTheme = matchMediaRef?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    root.classList.add(systemTheme);
    return;
  }

  root.classList.add(theme || 'dark');
};

export const savePreference = ({ save, value, isLoading, skipEmpty = false }) => {
  if (isLoading) return;
  if (skipEmpty && !value) return;
  save(value);
};

export const savePrayerStatusForToday = ({ save, prayerStatus, isLoading }) => {
  if (isLoading) return;

  const today = new Date().toISOString().split('T')[0];
  save({ date: today, data: prayerStatus });
};

export const buildSavedSoundSettings = (soundSettings) => ({
  ...(soundSettings || {}),
  adhanType: 'full'
});
